import { EditorItem } from '../../store/editorStore';
import { AITextItemContent } from './AITextItemContent';
import { AutoImageItemContent } from './AutoImageItemContent';
import { ImageItemContent } from './ImageItemContent';
import { TextItemContent } from './TextItemContent';

type ItemContentProps = {
  item: EditorItem;
  isEditing: boolean;
};

export function ItemContent({ item, isEditing }: ItemContentProps) {
  if (item.type === 'text') {
    return <TextItemContent item={item} isEditing={isEditing} />;
  } else if (item.type === 'image') {
    return <ImageItemContent item={item} />;
  } else if (item.type === 'auto-image' || item.type === 'auto-image-prompt') {
    return <AutoImageItemContent item={item} />;
  } if (item.type === 'ai-text') {
    return <AITextItemContent item={item}/>;
  }
  
  return null;
} 